export * from './ProductDetailsIngredient';
